export const constsConfig = {
  sep: '/'
}